// StartWorkButton.tsx
import React, { useState } from "react";
import { UniButton } from "../../../../../../@WUM/core/Elements";
import { clockTimingInterface } from "../../../../API/request/clockTimingInterface";
import {EndDay, StartWork, StopBreak, StopWork} from "../../../../API/response/worktimeclock";

interface EndWorkButtonProps {
    onSuccess?: (result: clockTimingInterface) => void;
}

const StopWorkButton = ({ onSuccess }: EndWorkButtonProps) => {
    const [loading, setLoading] = useState(false);

    const handleStart = async () => {
        setLoading(true);
        await StopBreak();
        const result = await StopWork();
        setLoading(false);

        if (result) {
            localStorage.setItem("stopWork", new Date().toISOString());
            onSuccess?.(result);
        }
    };

    return (
        <UniButton disabled={loading} onClick={handleStart} class={" text-dark"} variant={"outline-warning"}>
            {loading ? "..." : "✋️ Arbeit unterbrechen"}
        </UniButton>
    );
};

export default StopWorkButton;
